// angular
import { CommonModule } from '@angular/common';
import { Component, effect, inject, input, output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// components
import { ToggleSwitchComponent } from '../toggle-switch/toggle-switch.component';

@Component({
  selector: 'pwj-sorts-bar',
  standalone: true,
  imports: [CommonModule, ToggleSwitchComponent, TranslateModule],
  templateUrl: './sorts-bar.component.html',
  styleUrl: './sorts-bar.component.scss',
})
export class SortsBarComponent {
  public activeTab!: string;
  public params!: Params;
  public currentPath!: string;
  public isVerifiedCompany: boolean = false;
  public isVerifiedStone: boolean = false;
  public isShowingSortMenu = false;

  // inputs
  sorts = input.required<string[]>();
  sortParamKey = input<string>('filter_status');
  translateKey = input.required<string>();
  verifyCompanyBtn = input<boolean>();
  verifyStoneBtn = input<boolean>();
  haveInitializeTab = input<boolean>(true);
  resultsCount = input<number>();
  containerClasses = input<string>();
  collapsible = input(false);
  searchTerm = input<string>();
  /** Optional filters trigger */
  showFiltersButton = input(false);
  /** Segmented pill tabs inside a bordered white bar (products listing). */
  variant = input<'default' | 'segmented'>('default');
  filtersClick = output<void>();

  // dependencies
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _router = inject(Router);

  constructor() {
    // get current query params
    this._activatedRoute.queryParams.subscribe(params => {
      this.params = params;
      if (params['business_verified']) {
        this.isVerifiedCompany = params['business_verified'];
      }

      if (params['specialist_verified']) {
        this.isVerifiedStone = params['specialist_verified'];
      }
    });

    // set current path
    this._activatedRoute.url.subscribe(([url]) => {
      this.currentPath = url?.path;
    });

    effect(() => {
      const alreadySelectedSort = this.params[this.sortParamKey()];

      if (!this.activeTab && !alreadySelectedSort) {
        if (this.haveInitializeTab()) {
          this.activeTab = this.sorts()?.[0]?.toUpperCase();
          this.setSortOnParams(this.activeTab);
        }
      } else {
        this.activeTab = this.params[this.sortParamKey()];
      }
    });
  }

  public selectTab(tab: string) {
    if (this.collapsible()) {
      this.toggleSortMenu();
    }

    const selectedTab = tab?.toUpperCase();

    if (this.activeTab === selectedTab) {
      this.activeTab = '';
      this.setSortOnParams(null);
    } else {
      this.activeTab = tab?.toUpperCase();
      this.setSortOnParams(this.activeTab);
    }
  }

  public onToggleSort(isSorted: boolean, sortName: string) {
    this.setSortOnParams(isSorted ? isSorted : null, sortName);
  }

  public setSortOnParams(sortValue: any, key?: string) {
    this._router.navigate([], {
      queryParams: {
        [key ? key : this.sortParamKey()]: sortValue,
        page: null,
        perPage: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  public toggleSortMenu() {
    this.isShowingSortMenu = !this.isShowingSortMenu;
  }

  onFiltersButtonClick(): void {
    this.filtersClick.emit();
  }
}
